Vue.component('ack-pac-dent', {
	delimiters: ['${', '}$'], // (i) We set up custom delimiters to avoid conflict with liquid interpolations.
	template: '#ack-pac-dent',
	mixins: [languageMixins],
	created() {
		if (!this.storeAvailable) {
			window.location = '/';
		}
	},
	mounted() {
		appLog.log('ack-pac-dent mounted');
		//this.setPageIsLoading(false)
	},
	props: {},
	computed: {
		//...Vuex.mapGetters('sliders', ['slidersLists']),
		...Vuex.mapGetters('articles', ['articlesArray']),
		...Vuex.mapGetters('localization', ['countryCode']),
		/*
      lastArticles(){
        let arr = []
        for (let index = 0; index < 3; index++) {
          const element = this.articlesArray[index];
          arr.push(element)
        }
        return arr
      },
      */
		isMobile() {
			return this.$parent.isMobile;
		},
		storeAvailable() {
			let avl = true;
			if (this.countryCode.toUpperCase() == 'US' || this.countryCode.toUpperCase() == 'CA') {
				avl = false;
			}
			return avl;
		},
		selectedShopifyProduct() {
			return PAC_DENT_COLLECTION.find((m) => {
				return m.id == this.selectedProductId;
			});
		},
	},
	data() {
		return {
			pageId: 'pac-dent-page',
			selectedProductId: '6908629811303',
			selectedCard: null,
			default_3dps_bundle: 'shop-3dps-6',
			pacDentInfo: {
				title_section: {
					id: 'gid://shopify/Product/6643132235879',
					title: 'pac_dent.main_title',
					subtitle: 'pac_dent.main_subtitle',
					title_img:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/Logo_Resize-08.png?v=1705913619',
					description: 'pac_dent.main_description',
					image_desktop:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Top_banner_a8c76259-a404-4df6-9944-6667150bb71d.jpg?v=1742183673',
					image_mobile: null,
					price: 0.0,
					currencyCode: 'NTD',
					currencySymbol: '$',
					learn_more_url: '',
				},
				feature_section: {
					description: null,
					default_img:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA_AI_V4_Orient_Stack___Nest.gif?v=1703654229',
					feature_items: [
						{
							title: 'pac_dent.feature_section.feature_items.item_one.title',
							description: 'pac_dent.feature_section.feature_items.item_one.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_Scanning.jpg?v=1721711488',
							open: true,
						},
						{
							title: 'pac_dent.feature_section.feature_items.item_two.title',
							description: 'pac_dent.feature_section.feature_items.item_two.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_1_CAM.jpg?v=1711699977',
							open: false,
						},
						{
							title: 'pac_dent.feature_section.feature_items.item_three.title',
							description: 'pac_dent.feature_section.feature_items.item_three.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_2_3D_Printing.jpg?v=1711699978',

							open: false,
						},
						{
							title: 'pac_dent.feature_section.feature_items.item_four.title',
							description: 'pac_dent.feature_section.feature_items.item_four.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_Cleaning_Process.jpg?v=1711699935',
							open: false,
						},
						{
							title: 'pac_dent.feature_section.feature_items.item_five.title',
							description: 'pac_dent.feature_section.feature_items.item_five.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_5_UV_Curing.jpg?v=1711699978',
							open: false,
						},
						{
							title: 'pac_dent.feature_section.feature_items.item_six.title',
							description: 'pac_dent.feature_section.feature_items.item_six.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_4_Characterization.jpg?v=1711699978',
							open: false,
						},
						{
							title: 'pac_dent.feature_section.feature_items.item_seven.title',
							description: 'pac_dent.feature_section.feature_items.item_seven.description',
							link: null,
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Workflow_6_Seating.jpg?v=1711699978',
							open: false,
						},
					],
				},
				media_grid_section: {
					title: 'pac_dent.media_grid_section.title',
					media_grid_collection: {
						main_item: {
							title: 'pac_dent.media_grid_section.media_grid_collection.main_item.title',
							description:
								'pac_dent.media_grid_section.media_grid_collection.main_item.description',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Successful_Cases_Nelson_Rego.jpg?v=1711699935',
						},
						secondary_item: {
							title: 'pac_dent.media_grid_section.media_grid_collection.tertiary_item_one.title',
							description:
								'pac_dent.media_grid_section.media_grid_collection.tertiary_item_one.description',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Successful_Cases_Gupta.jpg?v=1711699935',
						},
						tertiary_item_one: {
							title: 'pac_dent.media_grid_section.media_grid_collection.secondary_item.title',
							description:
								'pac_dent.media_grid_section.media_grid_collection.secondary_item.description',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Successful_Cases_Jose_Antonio.jpg?v=1711699977',
						},
						tertiary_item_two: {
							title: 'pac_dent.media_grid_section.media_grid_collection.tertiary_item_two.title',
							description:
								'pac_dent.media_grid_section.media_grid_collection.tertiary_item_two.description',
							img: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Successful_Cases_Eugene.jpg?v=1711699977',
						},
					},
				},
				video_section: {
					title: 'pac_dent.video_section.title',
					subtitle: null,
					description: 'pac_dent.video_section.description',
					video:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/ALPHA-AI_V4_Variable_Layer_Thickness.gif?v=1703654229',
				},
				product_menu_section: {
					menu_items: [
						{
							imageMenu:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Menu_Titan.png?v=1711523085',
							id: 'titan',
							productId: '6908629811303',
							link: '#titan',
						},
						{
							imageMenu:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Menu_Sculpture_2.0_13ed28a9-fbc9-47ce-93ce-2042957a3494.png?v=1711525002',
							id: 'sculpture_2',
							productId: '6908625911911',
							link: '#sculpture_2',
						},
						{
							imageMenu:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Menu_Denture_Base_2.0.png?v=1711523085',
							id: 'denture_2',
							productId: '6908632727655',
							link: '#denture_2',
						},
						{
							imageMenu:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Menu_N2-Free_Glaze.png?v=1742183673',
							id: 'n2_free_glaze',
							productId: '7211636359271',
							link: '#n2_free_glaze',
						},
						{
							imageMenu:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Menu_N2-Free_Palette.png?v=1742183673',
							id: 'n2_free_palette',
							productId: '7211598381159',
							link: '#n2_free_palette',
						},
						// { imageMenu: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Menu_Naturalizing_Kit_530f56c8-54a4-4826-80aa-c5b6375af293.png?v=1711525003', id: 'naturalizing_kit', productId: "6908051226727", link: '#naturalizing_kit' },
						// { imageMenu: 'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Menu_Glaze.png?v=1711523085', id: 'glaze', productId: "6909081944167", link: '#glaze' },
						{
							imageMenu:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Menu_Bond_Kit.png?v=1711523085',
							id: 'adhesive_kit',
							productId: '6908636790887',
							link: '#adhesive_kit',
						},
					],
				},
				article_section: {
					articles: [
						{
							title: 'The Future of 3D Printing in Dentistry',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Thumbnail_Lee_Culp.jpg?v=1711699935',
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/Lee%20Culp%20CDT%20Article.pdf',
						},
						{
							title: 'The Benefits of 3D Printing in Dentistry',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Thumbnail_Chonway.jpg?v=1711699978',
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/0723Odowling[5].pdf',
						},
						{
							title: 'The Advantages of 3D Printing in Dentistry',
							image:
								'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Thumbnail_O_Dowling.jpg?v=1711699978',
							url: 'https://cdn.ackuretta.com/downloads/pac-dent/IDV19N7_Why_I_Invested_Pacdent_6th.pdf',
						},
					],
				},
				first_image_section: {
					title: 'pac_dent.first_image_section.title',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Mechanical_Properties_Comparison_f06cfa47-5e5b-4dd7-92ed-6418e6464972.jpg?v=1742183674',
					notes: 'pac_dent.first_image_section.notes',
				},
				second_image_section: {
					title: 'pac_dent.second_image_section.title',
					image:
						'https://cdn.shopify.com/s/files/1/0276/4174/1415/files/PacDent_Page_Vita_Shades_c966d301-9d7c-4efa-9a3e-406742d2df46.jpg?v=1742183674',
				},
			},
		};
	},
	methods: {
		...Vuex.mapActions(['setPageIsLoading']),
		//...Vuex.mapActions('sliders', ['getSlideList'])
		onMainTranslationsLoaded() {},

		onResinMenuItemClick(item) {
			this.selectedProductId = item.productId;
		},
	},
	beforeDestroy() {},
	watch: {
		data1: {
			handler() {},
			deep: false,
		},
	},
});
